export default [
  {
    header: 'Catalogo Boma Tech',
    action: 'read',
    resource: 'ACL',
  },
  {
    title: 'Articoli',
    route: 'catalogo-articoli-tutti',
    icon: 'BookOpenIcon',
    /* tag: 'novità', */
    tagVariant: 'light-success',
    action: 'read',
    resource: 'ACL',
  },
  {
    title: 'Catalogo pdf',
    href: 'https://www.boma-tech.com/CATALOGO-BOMA-TECH-26.pdf',
    target: '_blank',
    icon: 'DownloadCloudIcon',
    action: 'read',
    resource: 'ACL',
  },
  {
    title: 'Schede tecniche veicoli',
    route: 'catalogo-schede-tecniche-veicoli',
    icon: 'DownloadCloudIcon',
    /* tag: 'novità', */
    tagVariant: 'light-success',
    action: 'read',
    resource: 'ACL',
  },
  {
    header: 'Assistenza',
    action: 'read',
    resource: 'ACL',
  },
  {
    title: 'Contatti',
    href: 'https://www.boma-tech.com/contatti',
    target: '_blank',
    icon: 'PhoneCallIcon',
    action: 'read',
    resource: 'ACL',
  },
  {
    title: 'Whatsapp',
    href: 'https://wa.me/393313384339',
    target: '_blank',
    icon: 'MessageCircleIcon',
    action: 'read',
    resource: 'ACL',
  },
  {
    title: 'Youtube Tutorials',
    href: 'https://www.youtube.com/@BomaTechService',
    target: '_blank',
    icon: 'YoutubeIcon',
    action: 'read',
    resource: 'ACL',
  },
  
]
